import React from 'react';
import { Shield, Award, Clock, Users } from 'lucide-react';
const AboutSection = () => {
  return <section id="about-section" className="py-16 md:py-24 bg-white" data-id="element-21" data-mp="2lbn699ddxxkj">
      <div className="container mx-auto px-4" data-id="element-22" data-mp="2gd3lhcaj2rtr">
        <div className="flex flex-col md:flex-row gap-12" data-id="element-23" data-mp="2gc264vmhbj68">
          {/* Left side image */}
          <div className="w-full md:w-1/2" data-id="element-24" data-mp="2bcz4ll5pjv30">
            <div className="relative" data-id="element-25" data-mp="2bgd6ksagm29x">
              <img src="https://images.unsplash.com/photo-1600132806370-bf17e65e942f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2094&q=80" alt="I75 Audio & Video, LLC technicians installing home theater system" className="w-full h-auto rounded-xl shadow-lg object-cover" style={{
              maxHeight: '500px'
            }} data-id="element-26" data-mp="27cnkqal65ysl" />
              <div className="absolute -bottom-8 -right-8 bg-blue-600 rounded-lg p-6 shadow-xl hidden md:block" data-id="element-27" data-mp="1jmt7vt0uoa8c">
                <div className="text-white text-center" data-id="element-28" data-mp="sscjd1mohfha">
                  <p className="text-4xl font-bold" data-id="element-29" data-mp="sqrqdgg0i4lj">20+</p>
                  <p className="text-sm uppercase tracking-wider" data-id="element-30" data-mp="xj2ms9bjn89c">
                    Years Experience
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Right side content */}
          <div className="w-full md:w-1/2" data-id="element-31" data-mp="nt9epiam1b9u">
            <div className="md:pl-6" data-id="element-32" data-mp="1biu16b5z2qnv">
              <p className="text-blue-600 font-semibold mb-2" data-id="element-33" data-mp="1bjvj8zleodf3">
                ABOUT OUR COMPANY
              </p>
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-34" data-mp="1ggvr9g1tfq8u">
                Southwest Florida's Premier AV & Smart Home Solutions Provider
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-35" data-mp="16ig0je6paizv">
                With over two decades of technology experience, Owner Chris Zino
                has navigated the industry's evolution from dial-up internet to
                fiber networks and beyond. Prior to founding i75 Audio & Video
                LLC in 2003, Chris worked in IT for a major Northeast cable
                company and brings extensive construction industry knowledge
                from his family background. This unique combination of technical
                expertise and project management experience enables i75 Audio &
                Video to deliver comprehensive technology solutions for both
                residential and commercial clients.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-36" data-mp="1ey58bktuwyfn">
                Let i75 Audio & Video help you or your business achieve all your
                technology needs.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-37" data-mp="152kazzzqgmc8">
                {[{
                icon: <Shield className="w-5 h-5" data-id="element-38" data-mp="2zgcwkrv9020l" />,
                title: 'Licensed & Insured',
                desc: 'Full coverage for your peace of mind'
              }, {
                icon: <Award className="w-5 h-5" data-id="element-39" data-mp="32yipbwdvu0nd" />,
                title: 'Certified Experts',
                desc: 'Factory-trained technicians'
              }, {
                icon: <Clock className="w-5 h-5" data-id="element-40" data-mp="3bqui3owgy06i" />,
                title: 'Prompt Service',
                desc: 'On-time arrivals guaranteed'
              }, {
                icon: <Users className="w-5 h-5" data-id="element-41" data-mp="2jzobqqq5n68s" />,
                title: 'Local Team',
                desc: 'Southwest Florida based'
              }].map((item, idx) => <div key={idx} className="flex items-start" data-id="element-42" data-mp="2szjrz9ykhrfo" data-mpi={idx}>
                    <div className="mr-4 bg-blue-100 p-3 rounded-full text-blue-600" data-id="element-43" data-mp="2t260pcx72czh">
                      {item.icon}
                    </div>
                    <div data-id="element-44" data-mp="8and9f2bhww5">
                      <h3 className="font-semibold text-gray-800" data-id="element-45" data-mp="89c93e4ymn4i">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 text-sm" data-id="element-46" data-mp="daru56750tmw">{item.desc}</p>
                    </div>
                  </div>)}
              </div>
              <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300 inline-flex items-center" onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }} data-id="element-47" data-mp="1h83yoejtqf3r">
                Get Your Free Quote Today
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-48" data-mp="2dyw3uh57ymqr">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-49" data-mp="2ix7euv7933ak" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default AboutSection;